import { render, staticRenderFns } from "./group-manager.vue?vue&type=template&id=75e0ff80&"
import script from "./group-manager.vue?vue&type=script&lang=js&"
export * from "./group-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports